<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}
</style>
<style lang="scss" scoped>
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg_3.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 10px 20px 20px 10px; background: rgba(3, 0, 108, 1)">
    <div class="biankuang">
      <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          {{ $t('jinshanshitianshebeinenghaozhanbi') }}
        </div>
      </div>

      <div style="display: flex;justify-content: space-between;padding: 10px 0;" :style="{ height: chartHeight + 'px' }">
        <div id="monitorEnergyDeviceThirtyRatioChart" style="flex:1" :style="{ height: chartHeight + 'px' }"></div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_device_thirty_ratio',
  components: {},
  props: {
    cockpitData: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      timer: null,
      chart1: null,
      option1: null,
      chartHeight: 0,
      produce: {}
    };
  },
  created() { },

  watch: {
    cockpitData(newValue, oldValue) {
      this.makeChart();
    }
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.makeChart();
    this.resize();
  },

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    makeChart() {
      let yData = this.cockpitData.top5In30.map(item => {
        return { name: item.name, value: item.percent };
      });
      this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 30;
      if (!this.chart1) {
        setTimeout(() => {
          this.initChart1();
        }, 100);
      }
      console.log(yData);
      setTimeout(() => {
        // this.option1.xAxis.data = xData;
        this.option1.series[0].data = yData;
        this.chart1.setOption(this.option1);
      }, 200);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 30;
        if (!this.chart1) {
          return;
        }

        this.chart1.getDom().style.height = this.chartHeight - 20 + 'px';
        this.chart1.resize();
      }, 800);
    },
    initChart1() {
      this.option1 = {
        tooltip: {
          trigger: 'item',
          valueFormatter: value => {
            return (value * 100).toFixed(2) + '%';
          }
        },
        legend: {
          top: 'bottom',
          textStyle: {
            color: 'white'
          }
        },

        series: [
          {
            name: '',
            type: 'pie',
            radius: [20, 90],
            center: ['50%', '40%'],
            roseType: 'area',
            label: {
              color: "#FFF"
            },
            // itemStyle: {
            //   borderRadius: 8
            // },
            itemStyle: {
              normal: {
                color: params => {
                  var colorList = [
                    new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: 'rgba(254, 149, 116, 0.99)' // 颜色渐变
                      },
                      {
                        offset: 1,
                        color: 'rgba(255, 111, 65, 1)' // 颜色渐变
                      }
                    ]),
                    new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: 'rgba(237, 197, 94, 1)' // 颜色渐变
                      },
                      {
                        offset: 1,
                        color: 'rgba(223, 141, 45, 1)' // 颜色渐变
                      }
                    ]),
                    new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: 'rgba(253, 235, 70, 1)' // 颜色渐变
                      },
                      {
                        offset: 1,
                        color: 'rgba(251, 199, 15, 1)' // 颜色渐变
                      }
                    ]),
                    new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: 'rgba(236, 251, 69, 1)' // 颜色渐变
                      },
                      {
                        offset: 1,
                        color: 'rgba(255, 252, 177, 1)' // 颜色渐变
                      }
                    ]),
                    new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#E5FFB9' // 颜色渐变
                      },
                      {
                        offset: 1,
                        color: '#C2FB64' // 颜色渐变
                      }
                    ])
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
            data: [] // [{ value: 40, name: 'rose 1' }, { value: 38, name: 'rose 2' }, { value: 32, name: 'rose 3' }, { value: 30, name: 'rose 4' }, { value: 28, name: 'rose 5' }]
          }
        ]
      };

      var chartDom = document.getElementById('monitorEnergyDeviceThirtyRatioChart');
      this.chart1 = this.echarts.init(chartDom);
      this.option1 && this.chart1.setOption(this.option1);
    }
  }
};
</script>
